export default class ClearTeamAssistAnswer {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.teamAssistPanel.remove();
  }
}
